
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RawMaterialMasterGrid extends _Ext.GridBase<RawMaterialMasterRow, any> {
        protected getColumnsKey() { return 'OMS.RawMaterialMaster'; }
        protected getDialogType() { return RawMaterialMasterDialog; }
        protected getIdProperty() { return RawMaterialMasterRow.idProperty; }
        protected getLocalTextPrefix() { return RawMaterialMasterRow.localTextPrefix; }
        protected getService() { return RawMaterialMasterService.baseUrl; }
        protected getInsertPermission() { return RawMaterialMasterRow.insertPermission; }
        protected getUpdatePermission() { return RawMaterialMasterRow.updatePermission; }
        protected getDeletePermission() { return RawMaterialMasterRow.deletePermission; }
        protected useViewMode() { return true; }
        public initDialog(dialog: RawMaterialMasterDialog) {
            super.initDialog(dialog);
            dialog.parentGrid = this;
        }


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}